/**
 * Registration abuse deterrence constants (main app).
 * Mirror: backend/src/config/registrationAbuse.ts
 */

/** Cloudflare Turnstile script + iframe origin (B4 registration widget). */
export const REGISTRATION_TURNSTILE_CSP_ORIGIN = 'https://challenges.cloudflare.com' as const;

export const REGISTRATION_TURNSTILE_TOKEN_FIELD = 'turnstileToken' as const;

export const REGISTRATION_TURNSTILE_SITE_ENV = 'REACT_APP_REGISTRATION_TURNSTILE_SITE_KEY' as const;

/** Fallback when dedicated registration site key unset — shared Cloudflare widget key. */
export const REGISTRATION_TURNSTILE_SITE_FALLBACK_ENV = 'REACT_APP_PASSPORT_TURNSTILE_SITE_KEY' as const;

export const REGISTRATION_RATE_LIMIT_WINDOW_MS = 15 * 60 * 1000;

export const REGISTRATION_RATE_LIMIT_MAX_PER_IP = 8;

export const REGISTRATION_EMAIL_COOLDOWN_WINDOW_MS = 24 * 60 * 60 * 1000;

export const REGISTRATION_EMAIL_COOLDOWN_MAX = 5;

export const REGISTRATION_ABUSE_ERROR_CODES = {
  TURNSTILE_REQUIRED: 'TURNSTILE_REQUIRED',
  TURNSTILE_FAILED: 'TURNSTILE_FAILED',
  TURNSTILE_NOT_CONFIGURED: 'TURNSTILE_NOT_CONFIGURED',
  REGISTRATION_RATE_LIMIT: 'REGISTRATION_RATE_LIMIT',
  REGISTRATION_EMAIL_COOLDOWN: 'REGISTRATION_EMAIL_COOLDOWN',
  DISPOSABLE_EMAIL_BLOCKED: 'DISPOSABLE_EMAIL_BLOCKED',
} as const;

export const REGISTRATION_ABUSE_USER_MESSAGES: Record<
  (typeof REGISTRATION_ABUSE_ERROR_CODES)[keyof typeof REGISTRATION_ABUSE_ERROR_CODES],
  string
> = {
  TURNSTILE_REQUIRED: 'Complete the security check and try again.',
  TURNSTILE_FAILED: 'Human verification failed. Please try again.',
  TURNSTILE_NOT_CONFIGURED: 'Registration verification is not configured. Contact support.',
  REGISTRATION_RATE_LIMIT: 'Too many registration attempts from this network. Please try again later.',
  REGISTRATION_EMAIL_COOLDOWN: 'Too many registration attempts for this email. Try again later.',
  DISPOSABLE_EMAIL_BLOCKED: 'Disposable email addresses are not allowed. Use a business email.',
};

export function getRegistrationAbuseUserMessage(code: unknown): string | null {
  if (typeof code !== 'string' || !code.trim()) return null;
  const key = code.trim() as keyof typeof REGISTRATION_ABUSE_USER_MESSAGES;
  return REGISTRATION_ABUSE_USER_MESSAGES[key] ?? null;
}

export function getRegistrationTurnstileSiteKey(): string {
  const dedicated = (process.env.REACT_APP_REGISTRATION_TURNSTILE_SITE_KEY || '').trim();
  if (dedicated) return dedicated;
  return (process.env.REACT_APP_PASSPORT_TURNSTILE_SITE_KEY || '').trim();
}
